import apiClient from "./api";

export function customerOrdersList() {
    return apiClient.get(`/v1/customer/orders`);
}





